<ng-template #templateRef>
  <mat-dialog-content>
    <mat-horizontal-stepper #stepper [linear]="true">
      <mat-step [stepControl]="relationForm" errorMessage="Fill in the required fields" label="Relation">
        <form #relationForm="ngForm">
          <div class="row">
            <div class="col-12">
              <app-relation-selector [(ngModel)]="Document.Relation" name="Relation" required></app-relation-selector>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <button class="float-left" mat-button matStepperPrevious>Back</button>
              <div class="fill-remaining-space"></div>
              <button class="float-right" mat-button matStepperNext>Next</button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step label="Example of excell template">
        <div class="row">
          <div class="col-12">
            <p>Please follow the next steps carefully.</p>
            <ol>
              <li>Download the excel <a download="saleOrder_template.xlsx" href="./assets/sales_order_template.xlsx" target="_blank">template here.</a></li>
              <li>Complete the excel. <strong>Important: The tab should match exactly the name "Import"</strong>.</li>
              <li>Go to the next step to upload your completed template.</li>
            </ol>
            <p></p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="float-left" mat-button matStepperPrevious>Back</button>
            <div class="fill-remaining-space"></div>
            <button class="float-right" mat-button matStepperNext>Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step errorMessage="Fill in the required fields" label="Upload excell file">
        <div class="row">
          <div class="col-12">
            <form>
              <input (change)="readFile($event);" name="file" type="file">
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="float-left" mat-button matStepperPrevious>Back</button>
            <div class="fill-remaining-space"></div>
            <button class="float-right" mat-button matStepperNext>Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step errorMessage="Fill in the required fields" label="Validate">
        <div class="row">
          <div class="col-12">
            <table class="mat-mdc-table">
              <tr>
                <th>EAN Code</th>
                <th>Amount</th>
                <th>Price</th>
                <th>Validated</th>
              </tr>
              <tr *ngFor="let row of Data">
                <td>{{row.ArticleCode}}</td>
                <td>{{row.Ordered}}</td>
                <td>{{row.Article?.SalesPrice}}</td>
                <td>
                  <mat-spinner *ngIf="row.IsLoading" [diameter]="20"></mat-spinner>
                  <mat-icon *ngIf="!row.IsLoading">{{row.Article ? 'check' : 'close'}}</mat-icon>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="float-left" mat-button matStepperPrevious>Back</button>
            <div class="fill-remaining-space"></div>
            <button class="float-right" (click)="import()" [disabled]="isLoading()" mat-button>Import</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>
</ng-template>
